import axios from "axios";
import config from '../constants/config.json';

function getBaseUrl() {
 
    /*switch (process.env.NODE_ENV) {
        case 'production':
            return config.api.url.production
        case 'development':
            return config.api.url.development
        default:
            return config.api.url.local
    }*/

    return process.env.REACT_APP_API_URL;
}

const instance = axios.create({
    baseURL: getBaseUrl(),
    headers: {
        "Content-type": "application/json",
    }
});

instance.interceptors.request.use(function (config) {
   

     const isCustomSpeech = config.url.startsWith('/custom-speech');

    if(isCustomSpeech) {
        config.headers['Content-Type'] = 'application/json';    
        config.headers['x-api-key'] = '6599468e-a3c2-4ec4-a2d0-076c8614646d';
    }
    else{
        const token = localStorage.getItem('jwt');
        if (token) {
            config.headers["x-access-token"] =  token;
        }
    }

   
   

    return config;
});

export default instance;